import copy from 'copy-to-clipboard';
import { useCallback, useEffect, useState } from 'react';
import { copiedToast } from 'src/components/common/toast';

export default function useCopyClipboard(
  timeout = 300,
): [boolean, (toCopy: string, msg?: string) => void] {
  const [isCopied, setIsCopied] = useState(false);

  const staticCopy = useCallback((text, msg = '') => {
    const didCopy = copy(text);
    setIsCopied(didCopy);
    copiedToast(msg);
  }, []);

  useEffect(() => {
    if (isCopied) {
      const hide = setTimeout(() => {
        setIsCopied(false);
      }, timeout);

      return () => {
        clearTimeout(hide);
      };
    }
    return undefined;
  }, [isCopied, setIsCopied, timeout]);

  return [isCopied, staticCopy];
}
